import React from 'react'

const AccidentalWindowClose = ({ setShowerr }: any) => {

	window.onbeforeunload = function (e: { returnValue: string; }) {
		var dialogText = 'We are saving the status of your listing. Are you realy sure you want to leave?';
		e.returnValue = dialogText;
		return dialogText;
	};

	// window.onfocus = () => {
	// 	console.log("gained focus");
	// };

	window.onblur = () => {
		setShowerr(true);
		// console.log("lost focus");
	};
	return (
		<div>

		</div>
	)
}

export default AccidentalWindowClose
